// ~-~-~-~-~-~-~-
// Schema
// ~-~-~-~-~-~-~-

enum QuotaStatusBannerEnum {
  NoEnforcement = "NoEnforcement",
  ApproachingLimit = "ApproachingLimit",
  ReachedLimit = "ReachedLimit",
}

export interface IPaymentStatusBadge {
  text: PaymentStatusBadgeTextEnum;
  type: PaymentStatusBadgeTypeEnum;
}

export enum PaymentStatusBadgeTextEnum {
  Free = "Free",
  Pro = "Pro",
  Business = "Business",
  Enterprise = "Enterprise",
}

export enum PaymentStatusBadgeTypeEnum {
  Blue = "Blue",
  Gradient = "Gradient",
}

export interface IMixedFreemiumOrgUiState {
  quotaStatusBanner: QuotaStatusBannerEnum;
  autopilotPaused: boolean;
  moveRangesEnabled: boolean;
  paymentStatusBadge: IPaymentStatusBadge | null;
}

export enum MeetingReliefSettingVisibility {
  HideSetting = "HideSetting",
  DisabledByPaywall = "DisabledByPaywall",
  ShowWithBadge = "ShowWithBadge",
  ShowWithoutBadge = "ShowWithoutBadge",
}

export interface TrialMetadata {
  __typename: "TrialMetadata";
  trialEndDate: string;
  timeZone: string;
}

// ~-~-~-~-~-~-~-
// Redux
// ~-~-~-~-~-~-~-
export interface IFeatureGridReduxState {
  mixedFreemiumOrgUIState: IMixedFreemiumOrgUiState;
  meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
  trialMetadata?: TrialMetadata;
}

export const initialFeatureGridState: IFeatureGridReduxState = {
  mixedFreemiumOrgUIState: {
    quotaStatusBanner: QuotaStatusBannerEnum.NoEnforcement,
    autopilotPaused: false,
    moveRangesEnabled: true,
    paymentStatusBadge: null,
  },
  meetingReliefSettingVisibility: MeetingReliefSettingVisibility.HideSetting,
};
